<template>

  <el-card class="card-nabidka">
    <img :src="props.card.ic" :alt="props.card.nazev" height=80 > 
    <h4>{{ props.card.nazev }}</h4>
    <p>{{ props.card.text }}</p>

  </el-card>
    
</template>

<script>
export default {
    name: "KartaNabidka",
    props: {
        card: Object
    },
    setup(props){
        return {props}
    }  
}
</script>

<style scoped>
.card-nabidka {
    text-align: center;
    width: 300px;
    max-width: 90vw;
    height: 300px;
    cursor: pointer;
    box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px !important;

}
img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  transition: width 0.2s, height 0.2s;
}


</style>